<h1 mat-dialog-title>{{'common.confirm_header' | translate}}</h1>
<div id="divDialogContent" mat-dialog-content>
  <p id="pMessage" [innerHtml]="data.message"></p>
</div>
<div id="divDialogAction" mat-dialog-actions>
  <button id="btnYes" mat-button mat-dialog-close="yes" cdkFocusInitial>
    {{'common.yes_btn' | translate}}
  </button>
  <button id="btnNo" mat-button mat-dialog-close="no">{{'common.no_btn' | translate}}</button>
</div>
